/*!
   * Video metadata and thumbnails v1.0.21
   *
   * @author wangweiwei
   */
function e(e) {
  var t = this.constructor;
  return this.then(function (n) {
    return t.resolve(e()).then(function () {
      return n;
    });
  }, function (n) {
    return t.resolve(e()).then(function () {
      return t.reject(n);
    });
  });
}

var t = setTimeout;

function n(e) {
  return Boolean(e && void 0 !== e.length);
}

function r() {}

function o(e) {
  if (!(this instanceof o)) throw new TypeError("Promises must be constructed via new");
  if ("function" != typeof e) throw new TypeError("not a function");
  this._state = 0, this._handled = !1, this._value = void 0, this._deferreds = [], d(e, this);
}

function i(e, t) {
  for (; 3 === e._state;) {
    e = e._value;
  }

  0 !== e._state ? (e._handled = !0, o._immediateFn(function () {
    var n = 1 === e._state ? t.onFulfilled : t.onRejected;

    if (null !== n) {
      var r;

      try {
        r = n(e._value);
      } catch (e) {
        return void u(t.promise, e);
      }

      a(t.promise, r);
    } else (1 === e._state ? a : u)(t.promise, e._value);
  })) : e._deferreds.push(t);
}

function a(e, t) {
  try {
    if (t === e) throw new TypeError("A promise cannot be resolved with itself.");

    if (t && ("object" == typeof t || "function" == typeof t)) {
      var n = t.then;
      if (t instanceof o) return e._state = 3, e._value = t, void l(e);
      if ("function" == typeof n) return void d((r = n, i = t, function () {
        r.apply(i, arguments);
      }), e);
    }

    e._state = 1, e._value = t, l(e);
  } catch (t) {
    u(e, t);
  }

  var r, i;
}

function u(e, t) {
  e._state = 2, e._value = t, l(e);
}

function l(e) {
  2 === e._state && 0 === e._deferreds.length && o._immediateFn(function () {
    e._handled || o._unhandledRejectionFn(e._value);
  });

  for (var t = 0, n = e._deferreds.length; t < n; t++) {
    i(e, e._deferreds[t]);
  }

  e._deferreds = null;
}

function s(e, t, n) {
  this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.promise = n;
}

function d(e, t) {
  var n = !1;

  try {
    e(function (e) {
      n || (n = !0, a(t, e));
    }, function (e) {
      n || (n = !0, u(t, e));
    });
  } catch (e) {
    if (n) return;
    n = !0, u(t, e);
  }
}

o.prototype.catch = function (e) {
  return this.then(null, e);
}, o.prototype.then = function (e, t) {
  var n = new this.constructor(r);
  return i(this, new s(e, t, n)), n;
}, o.prototype.finally = e, o.all = function (e) {
  return new o(function (t, r) {
    if (!n(e)) return r(new TypeError("Promise.all accepts an array"));
    var o = Array.prototype.slice.call(e);
    if (0 === o.length) return t([]);
    var i = o.length;

    function a(e, n) {
      try {
        if (n && ("object" == typeof n || "function" == typeof n)) {
          var u = n.then;
          if ("function" == typeof u) return void u.call(n, function (t) {
            a(e, t);
          }, r);
        }

        o[e] = n, 0 == --i && t(o);
      } catch (e) {
        r(e);
      }
    }

    for (var u = 0; u < o.length; u++) {
      a(u, o[u]);
    }
  });
}, o.resolve = function (e) {
  return e && "object" == typeof e && e.constructor === o ? e : new o(function (t) {
    t(e);
  });
}, o.reject = function (e) {
  return new o(function (t, n) {
    n(e);
  });
}, o.race = function (e) {
  return new o(function (t, r) {
    if (!n(e)) return r(new TypeError("Promise.race accepts an array"));

    for (var i = 0, a = e.length; i < a; i++) {
      o.resolve(e[i]).then(t, r);
    }
  });
}, o._immediateFn = "function" == typeof setImmediate && function (e) {
  setImmediate(e);
} || function (e) {
  t(e, 0);
}, o._unhandledRejectionFn = function (e) {
  "undefined" != typeof console && console && console.warn("Possible Unhandled Promise Rejection:", e);
};

var c = function () {
  if ("undefined" != typeof self) return self;
  if ("undefined" != typeof window) return window;
  if ("undefined" != typeof global) return global;
  throw new Error("unable to locate global object");
}();
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */


function v(e, t, n, r) {
  return new (n || (n = Promise))(function (o, i) {
    function a(e) {
      try {
        l(r.next(e));
      } catch (e) {
        i(e);
      }
    }

    function u(e) {
      try {
        l(r.throw(e));
      } catch (e) {
        i(e);
      }
    }

    function l(e) {
      e.done ? o(e.value) : new n(function (t) {
        t(e.value);
      }).then(a, u);
    }

    l((r = r.apply(e, t || [])).next());
  });
}

function f(e, t) {
  var n,
      r,
      o,
      i,
      a = {
    label: 0,
    sent: function sent() {
      if (1 & o[0]) throw o[1];
      return o[1];
    },
    trys: [],
    ops: []
  };
  return i = {
    next: u(0),
    throw: u(1),
    return: u(2)
  }, "function" == typeof Symbol && (i[Symbol.iterator] = function () {
    return this;
  }), i;

  function u(i) {
    return function (u) {
      return function (i) {
        if (n) throw new TypeError("Generator is already executing.");

        for (; a;) {
          try {
            if (n = 1, r && (o = 2 & i[0] ? r.return : i[0] ? r.throw || ((o = r.return) && o.call(r), 0) : r.next) && !(o = o.call(r, i[1])).done) return o;

            switch (r = 0, o && (i = [2 & i[0], o.value]), i[0]) {
              case 0:
              case 1:
                o = i;
                break;

              case 4:
                return a.label++, {
                  value: i[1],
                  done: !1
                };

              case 5:
                a.label++, r = i[1], i = [0];
                continue;

              case 7:
                i = a.ops.pop(), a.trys.pop();
                continue;

              default:
                if (!(o = (o = a.trys).length > 0 && o[o.length - 1]) && (6 === i[0] || 2 === i[0])) {
                  a = 0;
                  continue;
                }

                if (3 === i[0] && (!o || i[1] > o[0] && i[1] < o[3])) {
                  a.label = i[1];
                  break;
                }

                if (6 === i[0] && a.label < o[1]) {
                  a.label = o[1], o = i;
                  break;
                }

                if (o && a.label < o[2]) {
                  a.label = o[2], a.ops.push(i);
                  break;
                }

                o[2] && a.ops.pop(), a.trys.pop();
                continue;
            }

            i = t.call(e, a);
          } catch (e) {
            i = [6, e], r = 0;
          } finally {
            n = o = 0;
          }
        }

        if (5 & i[0]) throw i[1];
        return {
          value: i[0] ? i[1] : void 0,
          done: !0
        };
      }([i, u]);
    };
  }
}

"Promise" in c ? c.Promise.prototype.finally || (c.Promise.prototype.finally = e) : c.Promise = o, "function" != typeof Object.assign && Object.defineProperty(Object, "assign", {
  value: function value(e, t) {
    if (null == e) throw new TypeError("Cannot convert undefined or null to object");
    var n = Object(e);

    for (var r = 1; r < arguments.length; r++) {
      var o = arguments[r];
      if (null != o) for (var _e in o) {
        Object.prototype.hasOwnProperty.call(o, _e) && (n[_e] = o[_e]);
      }
    }

    return n;
  },
  writable: !0,
  configurable: !0
});

var m = function () {
  function e(e) {
    var t = this;
    if (this.thumbnails = [], this.option = {
      quality: .7,
      interval: 1,
      scale: .7,
      start: 0
    }, this.isStarted = !0, this.count = 0, this.version = "1.0.21", !e) throw new Error("video-metadata-thumbnails params error");
    this.videoElement = document.createElement("video"), this.videoElement.preload = "metadata", this.videoElement.muted = !0, this.videoElement.volume = 0, this.videoElement.crossOrigin = "anonymous";
    var n = document.createElement("canvas");
    this.canvas = n, this.canvasContext = n.getContext("2d");
    var r = window.URL || window.webkitURL;
    this.videoElement.src = "string" == typeof e || e instanceof String ? e : r.createObjectURL(e);

    var o = function o() {
      var e = t.videoElement.src;
      "string" == typeof e || e instanceof String || r.revokeObjectURL(t.videoElement.src), t.videoElement.removeEventListener("ended", o, !1);
    };

    this.videoElement.addEventListener("ended", o, !1);
  }

  return e.prototype.getVersion = function () {
    return this.version;
  }, e.prototype.getThumbnails = function (e) {
    var t = this;
    return e && (this.option = Object.assign(this.option, e)), new Promise(function (e, n) {
      var r = function r() {
        var e = t.option.interval || 1,
            n = t.videoElement;
        n.videoWidth, n.videoHeight, n.duration;
        t.isStarted ? (t.videoElement.currentTime = t.option.start, t.isStarted = !1) : t.videoElement.currentTime += e;
      },
          o = function o() {
        var i = t,
            a = i.option,
            u = i.videoElement,
            l = i.canvasContext,
            s = i.thumbnails,
            d = u.videoWidth,
            c = u.videoHeight,
            v = u.duration,
            f = a.quality,
            m = a.interval,
            h = a.start,
            p = a.end,
            E = a.scale,
            y = u.currentTime,
            w = y >= v || y > (void 0 === p ? v : p),
            b = m || 1,
            g = d * (E || 1),
            L = c * (E || 1);

        try {
          if (t.canvas.width = g, t.canvas.height = L, t.canvasContext.drawImage(t.videoElement, 0, 0, g, L), t.canvas.toBlob) t.canvas.toBlob(function (n) {
            if (l.clearRect(0, 0, g, L), l.restore(), w) return u.removeEventListener("canplaythrough", r, !1), u.removeEventListener("timeupdate", o, !1), void e(t.thumbnails);
            s.push({
              currentTime: h + b * t.count,
              blob: n
            }), t.count++;
          }, "image/jpeg", f);else {
            for (var _ = atob(t.canvas.toDataURL("image/jpeg", f).split(",")[1]), j = _.length, T = new Uint8Array(j), P = 0; P < j; P++) {
              T[P] = _.charCodeAt(P);
            }

            var R = new Blob([T], {
              type: "image/jpeg"
            });
            if (l.clearRect(0, 0, g, L), l.restore(), w) return u.removeEventListener("canplaythrough", r, !1), u.removeEventListener("timeupdate", o, !1), void e(t.thumbnails);
            s.push({
              currentTime: h + b * t.count,
              blob: R
            }), t.count++;
          }
        } catch (e) {
          n(e);
        }
      },
          i = function i() {
        t.videoElement.play(), t.videoElement.removeEventListener("progress", i, !1);
      };

      /^((?!chrome).)*safari((?!chrome).)*$/i.test(navigator.userAgent) && t.videoElement.addEventListener("progress", i, !1);

      var a = function a() {
        t.videoElement.removeEventListener("progress", i, !1), t.videoElement.removeEventListener("ended", a, !1), t.videoElement.removeEventListener("canplaythrough", r, !1), t.videoElement.removeEventListener("timeupdate", o, !1), t.videoElement.removeEventListener("error", u, !1);
      },
          u = function u() {
        var e = t.videoElement.error;
        n(e ? new Error("video-metadata-thumbnails error " + e.code + "; details: " + e.message) : new Error("video-metadata-thumbnails unknown error")), t.videoElement.removeEventListener("progress", i, !1), t.videoElement.removeEventListener("ended", a, !1), t.videoElement.removeEventListener("canplaythrough", r, !1), t.videoElement.removeEventListener("timeupdate", o, !1), t.videoElement.removeEventListener("error", u, !1);
      };

      t.videoElement.addEventListener("canplaythrough", r, !1), t.videoElement.addEventListener("timeupdate", o, !1), t.videoElement.addEventListener("ended", a, !1), t.videoElement.addEventListener("error", u, !1);
    });
  }, e.prototype.drawThumbnails = function () {}, e.prototype.getMetadata = function () {
    var e = this;
    return new Promise(function (t, n) {
      var r = function r() {
        try {
          var o = e.videoElement,
              i = o.videoWidth,
              a = o.videoHeight,
              u = o.duration;

          if (u === 1 / 0) {
            var l = function l() {
              e.videoElement.removeEventListener("timeupdate", l, !1), e.videoElement.removeEventListener("loadedmetadata", r, !1), t({
                width: Math.floor(100 * e.videoElement.videoWidth) / 100,
                height: Math.floor(100 * e.videoElement.videoHeight) / 100,
                duration: Math.floor(100 * e.videoElement.duration) / 100
              }), e.videoElement.currentTime = 0;
            };

            e.videoElement.addEventListener("timeupdate", l, !1), e.videoElement.currentTime = Number.MAX_SAFE_INTEGER;
          } else t({
            width: Math.floor(100 * i) / 100,
            height: Math.floor(100 * a) / 100,
            duration: Math.floor(100 * u) / 100
          }), e.videoElement.removeEventListener("loadedmetadata", r, !1);
        } catch (e) {
          n(e);
        }
      },
          o = function o() {
        e.videoElement.removeEventListener("loadedmetadata", r, !1), e.videoElement.removeEventListener("ended", o, !1), e.videoElement.removeEventListener("error", i, !1);
      },
          i = function i() {
        var t = e.videoElement.error;
        n(t ? new Error("video-metadata-thumbnails error " + t.code + "; details: " + t.message) : new Error("video-metadata-thumbnails unknown error")), e.videoElement.removeEventListener("loadedmetadata", r, !1), e.videoElement.removeEventListener("ended", o, !1), e.videoElement.removeEventListener("error", i, !1);
      };

      e.videoElement.addEventListener("loadedmetadata", r, !1), e.videoElement.addEventListener("ended", o, !1), e.videoElement.addEventListener("error", i, !1);
    });
  }, e;
}();

function h(e) {
  return v(this, void 0, void 0, function () {
    return f(this, function (t) {
      switch (t.label) {
        case 0:
          return [4, new m(e).getMetadata()];

        case 1:
          return [2, t.sent()];
      }
    });
  });
}

function p(e, t) {
  return v(this, void 0, void 0, function () {
    return f(this, function (n) {
      switch (n.label) {
        case 0:
          return [4, new m(e).getThumbnails(t)];

        case 1:
          return [2, n.sent()];
      }
    });
  });
}

export { m as Video, h as getMetadata, p as getThumbnails };